import React, { useEffect } from "react";
import { Button, Row, Col } from "reactstrap";
import { DivPreview, Loader, PreviewIframe, Fallback } from "./styles";

const IframeCard = ({ onRefresh }) => {
 
  useEffect(() => {
    if (onRefresh) {
      onRefresh();
    }  // eslint-disable-next-line
  }, []);
 
  return (
    <Row>
      <Col style={{ textAlign: "right" }}>
        <Button
          className="btn-simple"
          color="info"
          type="button"
          onClick={onRefresh}
        >
          Atualizar pré-visualização
        </Button>

        <DivPreview>
          <Loader id="loader">
            <span>Carregando...</span>
          </Loader>

          <PreviewIframe id="tagPreview" />

          <Fallback id="fallback">
            <span>Pré-visualização não disponível</span>
          </Fallback>
        </DivPreview>
      </Col>
    </Row>
  );
};

export default IframeCard;
